import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import {useTranslation} from "react-i18next";

const actionStyles = css`
  border: 0;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 5px;
`;

export const ActionLink = styled(Link)`
  color: ${({ theme }) => theme.baseBlue.a6};
  ${actionStyles}
`;

export const ActionButton = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  ${actionStyles}
`;

const MessageWrapper = styled.div`
  padding: 60px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

interface Props {
  click?: () => void;
  link?: string;
  linkKey?: string;
  errorKey?: string;
  messageKey?: string;
}

const EmptyTableInner: FC<Props> = props => {
  const { t } = useTranslation();
  return (
    <MessageWrapper>
      {props.errorKey ? (
        <span data-translation={props.errorKey}>{t(props.errorKey)}</span>
      ) : props.messageKey ? (
        <span data-translation={props.messageKey}>{t(props.messageKey)}</span>
      ) : null}
      {props.link && props.linkKey && (
        <ActionLink to={props.link} data-translation={props.linkKey}>
          {t(props.linkKey)}
        </ActionLink>
      )}
      {props.click && props.linkKey && (
        <ActionButton onClick={props.click} data-translation={props.linkKey}>
          {t(props.linkKey)}
        </ActionButton>
      )}
    </MessageWrapper>
  );
};

export default EmptyTableInner;
